// Module
var code = `<a class="struct-alloc-cache" href> </a>
<div class="struct-alloc-call"> </div>
<a class="struct-alloc-link" title href> </a>
<div class="struct-alloc-metadata">
    (<span class="struct-alloc-syscalls-num"> </span> syscalls)
</div>`;
// Exports
export default code;